import styled from 'styled-components';

export default styled.img`
  height: ${props => props.height};
  width: ${props => props.width};
`;
